import { Dialog, Grid2 } from "@mui/material";
import useUIBp from "../../../../Hooks/useUIBoilerplate";
import { useWorker } from "../../../../Hooks/useWorker";
import { UIactions } from "../../../../store/slices/UI";
import BasicDialogActions from "../../../UI/BasicDialog/BasicDialogActions";
import BasicDialogContent from "../../../UI/BasicDialog/BasicDialogContent";
import BasicDialogTitle from "../../../UI/BasicDialog/BasicDialogTitle";
import { getMailId } from "../../Actions/getMail";
import Actions from "./Components/Actions";
import Contains from "./Components/Fields/Contains";
import FromDate from "./Components/Fields/DateFrom";
import UntilDate from "./Components/Fields/DateUntil";
import From from "./Components/Fields/From";
import Subject from "./Components/Fields/Subject";
import To from "./Components/Fields/To";

const UITextHeader = {
  "es-CL": { header: "Filtro avanzado" },
  "en-US": { header: "Advanced filter" },
};

const AdvancedSearch = () => {
  const { auth, dispatch, UI } = useUIBp();
  const { done } = useWorker(getMailId);
  const { payload = {} } = UI.modal ?? {};
  const { id: mailId } = payload;

  // useEffect(() => {
  //   if (!done) {
  //     const controller = new AbortController();
  //     dispatch(getMail({ ...auth, mailId, controller }));
  //     return () => {
  //       controller.abort();
  //     };
  //   }
  // }, [dispatch, auth, mailId, done]);

  // useEffect(() => {
  //   return () => {
  //     dispatch(UIactions.clear("modal"));
  //     dispatch(UIactions.clear(iframeHeightUI));
  //     dispatch(warehouseActions.unload(mailData));
  //     dispatch(workerActions.clear(getMailId));
  //   };
  // }, [dispatch]);

  const onClose = () => {
    dispatch(UIactions.closeModal());
  };

  return (
    <Dialog fullWidth {...{ open: true, onClose, maxWidth: "md" }}>
      <BasicDialogTitle header="Busqueda avanzada" />
      <BasicDialogContent>
        <Grid2 container spacing={1}>
          <From />
          <To />
          <Subject />
          <Contains />
          <FromDate />
          <UntilDate />
        </Grid2>
      </BasicDialogContent>
      <BasicDialogActions>
        <Actions {...{ onClose }} />
      </BasicDialogActions>
    </Dialog>
  );
};

export default AdvancedSearch;
